import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GenericChat } from '../GenericChat/GenericChat';
import { formatTextToUseNewLineBeforeNumbers, formmatedTrials } from '../functions';
import { useChat } from '../useChat';
import { CHAT_ROLES, NEW_USER_CHAT_ROOM } from '../constants';
import { formmatedlData, handleSendMessageByReturnUser } from './functions';

const INIT_USER_MESSAGE = 'Hello';

// does not account logout without page refresh
let _newSessionFromUi = true;

// old version
export const NewUserChat = () => {
  const { trials, treatmentsCategories } = useSelector((state) => state.matches);
  const { data: profile } = useSelector((state) => state.profile);
  const [init, setInit] = useState(null);
  const [newSessionFromUi, setNewSessionFromUi] = useState(_newSessionFromUi);
  const [payload, setPayload] = useState({ ...profile });
  const [socTreatmentsCategories, setSocTreatmentsCategories] = useState([]);
  const userTrialList = formmatedTrials(trials);
  const userSponsoredTrials = trials.filter((trial) => trial?.isSponsored);

  const {
    chat: { messageHistory: chatHistory } = {},
    addMessages,
  } = useChat(NEW_USER_CHAT_ROOM);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setPayload(
      formmatedlData(
        payload,
        userTrialList,
        userSponsoredTrials,
        socTreatmentsCategories,
      ),
    );
    if (treatmentsCategories) {
      setSocTreatmentsCategories(
        treatmentsCategories
          .filter((i) => !i.treatment_category_key.includes('supportive_care'))
          .map((i) => i.treatment_category_key),
      );
    } else {
      setSocTreatmentsCategories([]);
    }

    if (!chatHistory?.length) {
      setPayload({ ...payload });
    }
    if (newSessionFromUi) {
      const sendMessage = async () => {
        await handleSendMessageByReturnUser(INIT_USER_MESSAGE, payload, addMessages);
        _newSessionFromUi = false;
        setNewSessionFromUi(false);
      };

      sendMessage();
    }
    setInit(true);
  }, []);

  const handleSendMessageClick = (inputMessage) => {
    addMessages([{ content: formatTextToUseNewLineBeforeNumbers(inputMessage), role: CHAT_ROLES.ME }]);
    return handleSendMessageByReturnUser(inputMessage, payload, addMessages);
  };

  return (
    <GenericChat
      isFullMode
      showSpinnerOnly={init && newSessionFromUi}
      handleSendMessageClick={handleSendMessageClick}
      chatHistory={chatHistory}
    />
  );
};
